import apiService from "./ApiService";
import { ApiEndpoints } from "./ApiConstants";

export const getTopBatters = (page = 0, size = 10, range = "all") => {
    return apiService
        .get(ApiEndpoints.TOP_BATTERS, { params: { page, size, range } })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getTopBowlers = (page = 0, size = 10, range = "all") => {
    return apiService
        .get(ApiEndpoints.TOP_BOWLERS, { params: { page, size, range } })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getTopScores = (page = 0, size = 10, range = "all") => {
    return apiService
        .get(ApiEndpoints.TOP_SCORES, { params: { page, size, range } })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getHeadToHead = (team1Id, team2Id) => {
    return apiService
        .get(ApiEndpoints.HEAD_TO_HEAD, { params: { team1Id, team2Id } })
        .then((response) => response.data)
        .catch((error) => error.response);
};

export const getSessionStats = (range = "today") => {
    return apiService
        .get(ApiEndpoints.SESSION_STATS, { params: { range } })
        .then((response) => response.data)
        .catch((error) => error.response);
};